module.exports = __webpack_public_path__ + "img/asset-tier-2.7b6527e6.svg";